import { PeriodMode } from "../utils/period";

export default function PeriodToggle({
  value,
  onChange,
}: {
  value: PeriodMode;
  onChange: (v: PeriodMode) => void;
}) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <span
        className="period-label"
        style={{
          fontSize: "12px",
          fontWeight: 600,
          color: "var(--muted)",
          textTransform: "uppercase",
          letterSpacing: "0.05em",
        }}
      >
        Vista:
      </span>
      <div className="period-toggle" role="tablist" aria-label="Periodo">
        <button
          role="tab"
          aria-selected={value === "annual"}
          className={`ptab ${value === "annual" ? "on" : ""}`}
          onClick={() => onChange("annual")}
          type="button"
        >
          Anual
        </button>
        <button
          role="tab"
          aria-selected={value === "monthly"}
          className={`ptab ${value === "monthly" ? "on" : ""}`}
          onClick={() => onChange("monthly")}
          type="button"
        >
          Mensual
        </button>
      </div>
    </div>
  );
}
